import React from "react";
import Flexbox from "flexbox-react";
import { Card, Divider } from "@blueprintjs/core";
import ScrollableDropdown from "../shared/ScrollableDropdown";
const SalaryGoalsCalculationSection = ({
  goalCycles,
  selectedGoalCycle,
  setSelectedGoalCycle,
  goals,
  calculation
}) => {

  return (
    <div className="section-card">
      <div className="section-card-header">
        <div className="salary-card-title">
          <span>Goal Cycle & Bonus</span>
        </div>

        <div className="salary-section-count">
          Section 2 of 2
        </div>
      </div>


      <Flexbox display="flex" flexDirection="row" gap="24px" padding="20px" justifyContent="flex-start">
        <ScrollableDropdown
          width={250}
          label={selectedGoalCycle?.title || "Goal Cycle"}
          items={goalCycles}
          getKey={g => g.id}
          getLabel={g => g.title}
          enableSearch
          onSelect={setSelectedGoalCycle}
        />
      </Flexbox>

      <Flexbox display="flex" flexDirection="column" gap="16px" padding="20px" >
        {goals?.length === 0 ? (
          <div className="empty-state">
            No goals available
          </div>
        ) : (
          goals?.length > 0 && goals?.map(goal => (
            <Card key={goal.id} style={{ marginBottom: "20px" }}>
              <div className="goal-header">
                <div>
                  <div className="goal-title">
                    {goal.title}
                  </div>
                </div>
              </div>

              <Flexbox display="flex" flexDirection="row" gap="24px" padding="20px" paddingTop="0px" justifyContent="space-between">
                <div className="goal-meta-container" >
                  <span className="goal-meta-title">Weight</span>
                  <strong className="goal-meta-value">
                    {goal.weight}%
                  </strong>
                </div>
                <div className="goal-meta-container" >
                  <span className="goal-meta-title">Progress (Achievement per Matrix)</span>
                  <strong className="goal-meta-value">
                    {goal.achieved}%
                  </strong>
                </div>
                <div className="goal-meta-container" >
                  <span className="goal-meta-title">Targeted amount</span>
                  <strong className="goal-meta-value">
                    ${goal.targeted_amount}
                  </strong>
                </div>
                <div className="goal-meta-container" >
                  <span className="goal-meta-title">Earned amount</span>
                  <strong className="goal-progress">
                    ${goal.earned_amount}
                  </strong>
                </div>
              </Flexbox>

              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{
                    width: `${goal.achieved}%`
                  }}
                />
              </div>
            </Card>
          ))
        )}
      </Flexbox>

      <Divider />

      {/* CALCULATED BONUS */}
      <div className="bonus-summary-section">
        <div className="bonus-summary-header">
          <span>Calculated Bonus</span>
          <span className="readonly-label">
            Read Only
          </span>
        </div>

        <div className="bonus-cards-grid">

          <div className="bonus-stat-card success">
            <div className="stat-label">
              Total Bonus Amount
            </div>

            <div className="stat-value">
              ${calculation?.total_bonus_amount || 0}
            </div>

            <div className="stat-subtitle">
              Earned bonus payout
            </div>
          </div>

          <div className="bonus-stat-card">
            <div className="stat-label">
              Total Annual CTC
            </div>

            <div className="stat-value">
              ${calculation?.total_salary || 0}
            </div>

            <div className="stat-subtitle">
              Annual Basic Salary + Bonus
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SalaryGoalsCalculationSection;